// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Grenada from '../_raw/flag/icon_flag_grenada.png';

export default () => <img src={Grenada} alt="Grenada" />;
